import {get, post, put} from './prize-request';

const token = localStorage.getItem('token')

// 抽奖 中奖记录
export const fetchMyRecordList = (data,config) => {
  return get('/record/list', data, config)
}

// 抽奖 活动信息
export const fetchActivityInfo = (data,config) => {
  return get('/activity/queryDetails', data, config)
}

// 抽奖 补录信息
export const updateRecordUser = (data,config) => {
  return put('/record/updateRecordUser', data, config)
}

// 抽奖 问卷跳转
export const jumpPrizePage = (data,config) => {
  return get('/wj_jump', data, config)
}
